import { gql } from '@apollo/client'

export default gql`
  query GetCurrentBattlePassPrizeSummary {
    getCurrentBattlePassPrizeSummary {
      items {
        prizeAssetName
        totalQty
      }
    }
  }
`
